import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

import styles from "./style.module.css";

import Loader from "../../../Utility/Loader";
import Card from "../../components/card/Card";
import Sidebar from "../../components/sidebar/sidebar";
import { fetchDataById } from "../../../../actions/Profile";

export default function ProfileDetails() {
  const params = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") || location.state?.profile_token;

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        if (!token) {
          console.warn("Security Alert: Missing profile_token. Access denied.");
          setProfile(null); // Effectively blocks access
          setLoading(false);
          return;
        }

        const data = await fetchDataById(params?.id, token);
        if (data) {
          setProfile(data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [params.id, token]);

  return (
    <Sidebar>
      <div className={styles.container}>
        {loading ? (
          <Loader />
        ) : profile ? (
          <Card show likes={true} {...profile} profile_token={token} />
        ) : (
          <div className={styles.chatPlaceholder}>
            <p>No record Found</p>
          </div>
        )}
      </div>
    </Sidebar>
  );
}
